export const ACCORDION_TITLES = {
	EVENT_DETAILS: 'Event Details',
	PACKAGE_AND_ADD_ONS: 'Package and Add ons',
	DRINKS_AND_ALCOHOL: 'Drinks & Alcohol',
	TERMS_AND_ADDITIONAL_DETAILS: 'Terms and Additional Details',
	PAYMENT_SCHEDULE: 'Payment Schedule',
} as const;
